/**
 * Utility functions for user management
 */

import { User } from '@shared/types'

/**
 * Get CSS classes for role badge styling
 */
export const getRoleBadgeColor = (role: User['role']): string => {
  switch (role) {
    case 'system_admin':
      return 'bg-red-100 text-red-800 border-red-200'
    case 'hr_admin':
      return 'bg-blue-100 text-blue-800 border-blue-200'
    case 'general_manager':
      return 'bg-green-100 text-green-800 border-green-200'
    case 'unassigned':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200'
    default:
      return 'bg-gray-100 text-gray-800 border-gray-200'
  }
}

/**
 * Format role for display
 */
export const formatRole = (role: User['role']): string => {
  switch (role) {
    case 'system_admin':
      return 'System Admin'
    case 'hr_admin':
      return 'HR Admin'
    case 'general_manager':
      return 'General Manager'
    case 'unassigned':
      return 'Pending Approval'
    default:
      return role
  }
}

/**
 * Get user initials for avatar
 */
export const getUserInitials = (firstName: string, lastName?: string): string => {
  if (lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }
  return firstName.charAt(0).toUpperCase()
}

/**
 * Get role options for select dropdown
 */
export const getRoleOptions = () => [
  { value: '', label: 'All Roles' },
  { value: 'system_admin', label: 'System Admin' },
  { value: 'hr_admin', label: 'HR Admin' },
  { value: 'general_manager', label: 'General Manager' },
  { value: 'unassigned', label: 'Pending Approval' }
] 